import { get_axios_instance, api_variables, errorHandler } from '@/apis/variables.js';

var axios_instance = get_axios_instance(api_variables.SERVICE_UPLOAD_FBP_CLAIMS);

const _pk_name = "id";

const state = {
  data:[],
  exits: {},
  isFetching: false,
  isSaving: false,
  isDeleting: false
};

const mutations = {
  set: (state, payload) => {
    state.data = payload;
    //console.log('fetched data', state.data)
  },

  setExits: (state, payload) => {
    if(payload) {
      state.exits = payload;
    }
    //console.log('fetched exits', state.exits)
  },

  addEmployee: (state, payload) => {
    //console.log('payload data from store', payload)
    state.exits = payload;
    //console.log('exit data', state.exits);
    //console.log('state data', state.data);
    // state.data.push(payload);
  },


  setFetching: (state, payload) => {
    state.isFetching = payload;
  },

  setSaving: (state, payload) => {
    state.isSaving = payload;
  },

  setDeleting: (state, payload) => {
    state.isDeleting = payload;
  },
}

const actions = {
  async fetchAll({commit}, payload) {
      //console.log("[state/payroll/fbpClaims/fetchAll] Calling API...");
    try {
      commit("setFetching", true);
      let res = await axios_instance.get(`/`,{
        params: {
            le_id: payload
          }
      });
      commit("setFetching", false);
      //console.log("[state/payroll/fbpClaims/fetchAll] res: ", res);
      if(res.status == 200) {
        commit("set", payload);
      }
      return res;
    }catch(err){
        //console.log('error',err);
        throw errorHandler(err.response);
    }
  },

async fetchExits({commit}, payload) {
  //console.log("[state/payroll/fbpClaims/fetchJoinings] Calling API...");
  //console.log('payload paygroup id', payload)
try {
  commit("setFetching", true);
  let res = await axios_instance.get(`/`, {
    params: {
      paygroupId: payload
    }
  });
  commit("setFetching", false);
  //console.log("[state/payroll/fbpClaims/fetchAll] res: ", res);
  if(res.status == 200) {
    commit("setExits", res.data.rows);
  }
  return res;
}catch(err){
  //console.log('error',err);
  throw errorHandler(err.response);
}
},

  async create({commit}, payload) {
      //console.log("[state/payroll/fbpClaims/create] Adding...", payload);
    try {
      commit("setSaving", true);
      let res = await axios_instance.post('/', payload);
      commit("setSaving", false);
      //console.log("[state/payroll/fbpClaims/create] res: ", res);
      if(res.status == 200) {
        commit("addEmployee", payload);
      }
      return res;
    }catch(err) {
      //console.log('error',err);
      throw errorHandler(err.response);
    }
  },

  async update({commit}, payload) {
      //console.log("[state/payroll/fbpClaims/update] Updating... Display payload", payload);
    try {
      commit("setSaving", true);
      let res = await axios_instance.put(`/${payload.id}`, payload);
      commit("setSaving", false);
      //console.log("[state/payroll/fbpClaims/update] res: ", res);
      if(res.status == 200) {
        commit("updateEmployeeById", res.data);
      }
      return res;
    }catch(err) {
      //console.log('error',err);
      throw errorHandler(err.response);
    }
  },

  async delete({commit}, payload) {
    //console.log("[state/payroll/fbpClaims/delete] Payload:", payload);
    //console.log("[state/payroll/fbpClaims/delete] Payload:", `/${payload.id}`);
    try {
      commit("setDeleting", true);
      let res = await axios_instance.delete(`/${payload.id}`);
      commit("setDeleting", false);
      if (res.status == 200){
        commit("removeEmployeeById", payload.id);
      }
    }catch(err) {
      //console.log('error',err);
      throw errorHandler(err.response);
    }
  }
}

export default {
  namespaced: true,
  state, mutations, actions
}
